import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    BlueTint
} from '../../Styles/BaseStyles'

import { 
    LOCDiv,
    LOCComponentsDiv,
    LOCContentsDiv,
    QuickFillerButtonDiv,
    TitleIconButton,
    QuickFillerButton,
    LOCTitle,
    LOCPhraseDiv,
    LOCPhrase,
    HereLink
} from '../../Styles/Components/LogOutConfirmStyles'

function LogOutConfirm(props){
    var history = useHistory()

    function mainPageTransition(){
        history.push('/')
    }

    return (
        <LOCDiv id="logout-confirm-section">
            <LOCComponentsDiv>
                <LOCContentsDiv>
                    <QuickFillerButtonDiv onClick={mainPageTransition}>
                        <TitleIconButton />
                        <QuickFillerButton><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                    </QuickFillerButtonDiv>
                    <LOCTitle>Successfully Logged Out</LOCTitle>
                    <LOCPhraseDiv>
                        <LOCPhrase>Click <HereLink href='' onClick={mainPageTransition}>here</HereLink> to go back to the Main page.</LOCPhrase>
                    </LOCPhraseDiv>
                </LOCContentsDiv>
            </LOCComponentsDiv>
        </LOCDiv>
    )
}

export default LogOutConfirm